var map = {
	"./address-card-regular.svg": 488,
	"./appstore.png": 5939,
	"./beckettfonden.png": 7295,
	"./book.svg": 9759,
	"./bullet.svg": 2224,
	"./bulletCurrent.svg": 3247,
	"./checklist.svg": 8304,
	"./checklistComplete.svg": 2453,
	"./checkmark-invalid.svg": 5101,
	"./checkmark-valid.svg": 7690,
	"./circle-user-regular.svg": 3779,
	"./clockIcon.svg": 8257,
	"./envelope-at.svg": 754,
	"./googleplay.png": 7576,
	"./helsefonden.png": 426,
	"./hjerteforeningen.png": 8576,
	"./light-bulb.svg": 7584,
	"./mitid.png": 2890,
	"./neckMeasure.svg": 1043,
	"./person-circle.svg": 5980,
	"./phone.svg": 4748,
	"./questionIcon.svg": 3991,
	"./radioButtonIcon.svg": 6854,
	"./region-hovedstaden.svg": 3280,
	"./sliderIcon.svg": 6240,
	"./sophus.png": 913,
	"./textAreaIcon.svg": 3669,
	"./textIcon.svg": 178,
	"./x.svg": 6248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;